import { Helper } from '../Helper';
export class ArrReduceHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
        this.withIndex = options.withIndex || false;
    }
    emit(sb, node, options) {
        if (this.withIndex) {
            sb.emitOp(node, 'SWAP');
            sb.emitSysCall(node, 'Neo.Iterator.Create');
            sb.emitOp(node, 'SWAP');
            sb.emitHelper(node, options, sb.helpers.rawIteratorReduce({
                each: (innerOptions) => {
                    sb.emitOp(node, 'ROT');
                    sb.emitOp(node, 'SWAP');
                    this.each(innerOptions);
                },
            }));
        }
        else {
            sb.emitOp(node, 'SWAP');
            sb.emitSysCall(node, 'Neo.Enumerator.Create');
            sb.emitOp(node, 'SWAP');
            sb.emitHelper(node, options, sb.helpers.rawEnumeratorReduce({
                each: this.each,
            }));
        }
    }
}

//# sourceMappingURL=ArrReduceHelper.js.map
